import { useState } from "react";
import { Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useGetVisitorQuery } from "../../features/CallApi";
import LoadScreen from "../UI/LoadScreen";
import axios from "axios";
import { useEffect } from "react";
import { set } from "date-fns";
import { useForm } from "react-hook-form";


export const EditVisitor = ({ id, modal, setModal, token, eventType, forceUpdate }) => {
    const toggle = () => setModal(!modal);
    const [isLoading, setIsLoading] = useState(false)
    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();


    useEffect(() => {
        setIsLoading(true)
        if (modal) {
            axios.get(`api/sessionevents/visitor/${id}`, {
                headers:
                {
                    Authorization: "Bearer " + token
                }
            }).then((response) => {
                console.log(response)
                setIsLoading(false)
                setValue("id", response.data ? response.data.id : "")
                setValue("name", response.data ? response.data.name : "")
                setValue("comment", response.data ? response.data.comment : "")
                setValue("order", response.data ? response.data.order : "")
                setValue("commentLine2", response.data ? response.data.commentLine2 : "")
                setValue("birthday", response.data ? new Date(response.data.birthday).toISOString().split('T')[0] : "")
                setValue("visitorStatus", response.data ? response.data.visitorStatus : "")
                setValue("barcode", response.data ? response.data.barcode : "")
            })
        }
    }, [modal])

    const putVisitor = (data) => {
        console.log(data)
        if (window.confirm(`Изменить статус?`)) {
            console.log(token)
            axios.put(`api/sessionevents/visitor/${data.id}`, data, {
                headers:
                {
                    Authorization: "Bearer " + token
                }
            }).then((response) => {
                console.log(response)
                forceUpdate(id)
            })
            toggle()
        }

    }


    // const { data, isLoading } = useGetVisitorQuery(id)

    return (
        <Modal isOpen={modal} toggle={toggle}>
            {!isLoading ?
                <form onSubmit={handleSubmit(putVisitor)}>
                    <ModalHeader toggle={toggle}></ModalHeader>
                    <ModalBody>
                        <div>
                            <input {...register("id")} hidden />
                            <div className="form-floating mb-3">
                                <input type="text" className="form-control" id="name" placeholder="name"
                                    {...register("name", { required: { value: true, message: "Поле Ф.И.О. обязательное" } })} />
                                <label htmlFor="name">Ф.И.О.</label>
                            </div>
                            <div className="form-floating mb-3">
                                <input type="text" className="form-control" id="comment" placeholder="comment"
                                    {...register("comment")} />
                                <label htmlFor="comment">Комментарий</label>
                            </div>
                            {eventType === 2 &&
                                <div className="form-floating mb-3">
                                    <input type="date" className="form-control" id="birthday" placeholder="Дата рождения"
                                        {...register("birthday")} />
                                    <label htmlFor="birthday">Дата рождения</label>
                                </div>
                            }
                            <div className="form-floating mb-3">
                                <select {...register("visitorStatus")} className="form-select" id="visitorStatus" aria-label="Статус">
                                    <option value={0}>Ожидаем</option>
                                    <option value={1}>На месте</option>
                                    <option value={2}>Сдал тест</option>
                                    <option value={3}>Вход разрешен</option>
                                    <option value={4}>Вход запрещен</option>
                                    <option value={5}>Заказ выдан</option>
                                </select>
                                <label htmlFor="visitorStatus">Статус</label>
                            </div>
                            {(eventType === 3 || eventType === 5) &&
                                <div>
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="commentLine2" placeholder="Доп. комментарий"
                                            {...register("commentLine2")} />
                                        <label htmlFor="commentLine2">Доп. комментарий</label>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="order" placeholder="Номер заказа"
                                            {...register("order")} />
                                        <label htmlFor="order">Номер заказа</label>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="barcode" placeholder="Штрих-код"
                                            {...register("barcode")} />
                                        <label htmlFor="barcode">Штрих-код</label>
                                    </div>
                                </div>
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <ButtonGroup>
                            <Button size="sm" color="success">
                                Сохранить
                            </Button>
                            <Button size="sm" color="secondary" onClick={() => {
                                reset()
                                toggle()
                            }}>
                                Отменить
                            </Button>
                        </ButtonGroup>
                    </ModalFooter>
                </form>
                : <LoadScreen />
            }
        </Modal>
    )
}